var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 57,
    viewBox: "0 0 165 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5073_2710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4657 55.2081C36.0792 60.3919 5.6062 35.2402 25.5728 23.6812C40.5438 15.0093 28.4344 -2.78525 12.9537 4.89388C-0.992728 11.8057 -9.15246 45.3825 20.4657 55.2081Z",
    fill: "url(#paint0_linear_5073_2710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.06176 20.6866C-4.06661 36.4689 20.8161 5.66645 32.2514 25.849C40.8305 40.9819 58.4347 28.7415 50.8377 13.0934C44 -1.00383 10.7823 -9.25179 1.06176 20.6866Z",
    fill: "url(#paint1_linear_5073_2710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2136 1.07249C19.6002 -4.11133 50.0732 21.035 30.1064 32.5993C15.1355 41.2713 27.2451 59.0659 42.7258 51.3867C56.6721 44.4749 64.8319 10.8981 35.2136 1.07249Z",
    fill: "url(#paint2_linear_5073_2710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6176 35.5944C59.7459 19.8121 34.8633 50.6146 23.4281 30.432C14.8489 15.2992 -2.75532 27.5396 4.83637 43.1877C11.6795 57.2849 44.897 65.5328 54.6176 35.5944Z",
    fill: "url(#paint3_linear_5073_2710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0946 56.6995C44.47 56.6995 56.9344 44.1004 56.9344 28.5587C56.9344 13.017 44.47 0.417969 29.0946 0.417969C13.7191 0.417969 1.25488 13.017 1.25488 28.5587C1.25488 44.1004 13.7191 56.6995 29.0946 56.6995Z",
    fill: "url(#paint4_linear_5073_2710)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6485 40.1409V16.835H75.2217C76.4869 16.835 77.6245 17.1458 78.6344 17.7673C79.6443 18.3888 80.4434 19.2267 81.0315 20.281C81.6308 21.3242 81.9305 22.4895 81.9305 23.7768C81.9305 24.8645 81.7252 25.8577 81.3145 26.7567C80.915 27.6556 80.349 28.4214 79.6166 29.054C78.8952 29.6865 78.0684 30.1416 77.1361 30.419L82.7628 40.1409H78.7509L73.2907 30.7353H70.1111V40.1409H66.6485ZM70.1111 27.2727H74.8555C75.5214 27.2727 76.1262 27.1062 76.67 26.7733C77.2249 26.4404 77.6633 25.9964 77.9851 25.4415C78.307 24.8866 78.4679 24.2596 78.4679 23.5604C78.4679 22.8613 78.307 22.2342 77.9851 21.6793C77.6633 21.1133 77.2249 20.6694 76.67 20.3476C76.1262 20.0146 75.5214 19.8481 74.8555 19.8481H70.1111V27.2727ZM100.431 23.4938H103.893V40.1409H100.414L100.281 37.7271C99.7927 38.5816 99.1323 39.2697 98.3 39.7913C97.4676 40.3129 96.4854 40.5737 95.3535 40.5737C94.1327 40.5737 92.984 40.3462 91.9075 39.8912C90.831 39.425 89.8821 38.7814 89.0609 37.9601C88.2507 37.1389 87.6181 36.1955 87.1631 35.1301C86.7081 34.0536 86.4806 32.8994 86.4806 31.6675C86.4806 30.48 86.7025 29.3647 87.1465 28.3215C87.5904 27.2672 88.2063 26.346 88.9943 25.5581C89.7822 24.7701 90.6923 24.1542 91.7244 23.7103C92.7676 23.2552 93.883 23.0277 95.0705 23.0277C96.2801 23.0277 97.3455 23.3052 98.2667 23.8601C99.1989 24.4039 99.9702 25.1031 100.581 25.9576L100.431 23.4938ZM95.2702 37.2276C96.2468 37.2276 97.1014 36.989 97.8339 36.5118C98.5663 36.0235 99.1323 35.3687 99.5319 34.5475C99.9425 33.7262 100.148 32.8162 100.148 31.8174C100.148 30.8074 99.9425 29.8919 99.5319 29.0706C99.1212 28.2493 98.5497 27.6001 97.8172 27.1229C97.0958 26.6346 96.2468 26.3904 95.2702 26.3904C94.3047 26.3904 93.4224 26.6346 92.6233 27.1229C91.8243 27.6112 91.1917 28.266 90.7256 29.0872C90.2595 29.9085 90.0264 30.8185 90.0264 31.8174C90.0264 32.8273 90.265 33.7429 90.7422 34.5641C91.2305 35.3743 91.8687 36.0235 92.6566 36.5118C93.4557 36.989 94.3269 37.2276 95.2702 37.2276ZM122.189 15.1703H125.651V40.1409H122.189V37.6938C121.645 38.5594 120.935 39.2586 120.058 39.7913C119.181 40.3129 118.155 40.5737 116.978 40.5737C115.769 40.5737 114.637 40.3462 113.582 39.8912C112.528 39.4361 111.596 38.8091 110.786 38.0101C109.986 37.1999 109.359 36.2677 108.904 35.2134C108.449 34.159 108.222 33.027 108.222 31.8174C108.222 30.6077 108.449 29.4757 108.904 28.4214C109.359 27.356 109.986 26.4237 110.786 25.6247C111.596 24.8145 112.528 24.1819 113.582 23.7269C114.637 23.2719 115.769 23.0444 116.978 23.0444C118.155 23.0444 119.181 23.3107 120.058 23.8434C120.935 24.365 121.645 25.0531 122.189 25.9077V15.1703ZM117.011 37.2276C117.988 37.2276 118.843 36.989 119.575 36.5118C120.308 36.0235 120.874 35.3687 121.273 34.5475C121.684 33.7262 121.889 32.8162 121.889 31.8174C121.889 30.8074 121.684 29.8919 121.273 29.0706C120.862 28.2493 120.291 27.6001 119.558 27.1229C118.837 26.6346 117.988 26.3904 117.011 26.3904C116.046 26.3904 115.164 26.6346 114.365 27.1229C113.577 27.6112 112.944 28.266 112.467 29.0872C112.001 29.9085 111.768 30.8185 111.768 31.8174C111.768 32.8273 112.006 33.7429 112.483 34.5641C112.972 35.3743 113.61 36.0235 114.398 36.5118C115.197 36.989 116.068 37.2276 117.011 37.2276ZM144.694 23.4938H148.156V40.1409H144.677L144.544 37.7271C144.056 38.5816 143.395 39.2697 142.563 39.7913C141.73 40.3129 140.748 40.5737 139.616 40.5737C138.396 40.5737 137.247 40.3462 136.17 39.8912C135.094 39.425 134.145 38.7814 133.324 37.9601C132.514 37.1389 131.881 36.1955 131.426 35.1301C130.971 34.0536 130.743 32.8994 130.743 31.6675C130.743 30.48 130.965 29.3647 131.409 28.3215C131.853 27.2672 132.469 26.346 133.257 25.5581C134.045 24.7701 134.955 24.1542 135.987 23.7103C137.03 23.2552 138.146 23.0277 139.333 23.0277C140.543 23.0277 141.608 23.3052 142.53 23.8601C143.462 24.4039 144.233 25.1031 144.843 25.9576L144.694 23.4938ZM139.533 37.2276C140.51 37.2276 141.364 36.989 142.097 36.5118C142.829 36.0235 143.395 35.3687 143.795 34.5475C144.205 33.7262 144.411 32.8162 144.411 31.8174C144.411 30.8074 144.205 29.8919 143.795 29.0706C143.384 28.2493 142.813 27.6001 142.08 27.1229C141.359 26.6346 140.51 26.3904 139.533 26.3904C138.568 26.3904 137.685 26.6346 136.886 27.1229C136.087 27.6112 135.455 28.266 134.988 29.0872C134.522 29.9085 134.289 30.8185 134.289 31.8174C134.289 32.8273 134.528 33.7429 135.005 34.5641C135.493 35.3743 136.132 36.0235 136.92 36.5118C137.719 36.989 138.59 37.2276 139.533 37.2276ZM153.809 40.1409V23.4938H157.271V25.2584C157.848 24.5704 158.559 24.0266 159.402 23.627C160.246 23.2275 161.156 23.0277 162.132 23.0277C162.754 23.0277 163.37 23.111 163.98 23.2774L162.598 26.7733C162.165 26.6068 161.733 26.5236 161.3 26.5236C160.567 26.5236 159.896 26.7067 159.286 27.073C158.675 27.4281 158.187 27.9109 157.821 28.5212C157.454 29.1316 157.271 29.8086 157.271 30.5522V40.1409H153.809Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5073_2710",
    x1: 32.4007,
    y1: 29.4589,
    x2: 0.372926,
    y2: 29.4589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000408522,
    stopColor: "#41EAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41EAD4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5073_2710",
    x1: 26.535,
    y1: 32.7507,
    x2: 26.535,
    y2: 0.376593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000408522,
    stopColor: "#41EAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41EAD4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5073_2710",
    x1: 23.2781,
    y1: 26.8212,
    x2: 55.306,
    y2: 26.8212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000408522,
    stopColor: "#41EAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41EAD4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5073_2710",
    x1: 29.1438,
    y1: 23.5298,
    x2: 29.1438,
    y2: 55.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000408522,
    stopColor: "#41EAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41EAD4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5073_2710",
    x1: 10.3047,
    y1: 49.3048,
    x2: 48.3779,
    y2: 8.23387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0724,
    stopColor: "#00FF73",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4948,
    stopColor: "#00FF73",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9255,
    stopColor: "#00FF73",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#00FF73"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5073_2710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 56.2815,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerLogo);
export default __webpack_public_path__ + "static/media/flower-logo.1e1b87c0453180a95c404a23739e7a08.svg";
export { ForwardRef as ReactComponent };